module.exports = __webpack_public_path__ + "img/qiu2.49bc4a6c.png";